import { SHOW_BREAKDOWN_ICON } from './constants'

export function showBreakdownIcon(iconKey) {
  return {
    type: SHOW_BREAKDOWN_ICON,
    iconKey,
  }
}
